import axios from 'axios';
import { Organization } from '../interfaces/api/organization';

export async function getOrganizations(): Promise<Organization[]> {
	try {
		const response = await axios.get<Organization[]>('api/organizations/');
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response;
		}
		throw error;
	}
}

export async function getOrganization(id: number): Promise<Organization> {
	try {
		const response = await axios.get<Organization>(`api/organizations/${id}/`);
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response;
		}
		throw error;
	}
}
